import React from 'react';
import { GameClockModel, TeamScoreModel } from '../../models/scoreBoardModels';
import PenaltyBoard from '../penaltyBoard/penaltyBoard';
import { createPerodioTimeString } from '../../utils/clockHelpers';
import styles from './scoreBoard.module.scss';
import salbaLogo from '../../assets/images/salba.webp';
import karhutLogo from '../../assets/images/karhut.webp';

interface ScoreBoardProps {
    clock: GameClockModel;
    home: TeamScoreModel;
    away: TeamScoreModel;
}

const ScoreBoard: React.FC<ScoreBoardProps> = ({
    clock,
    home,
    away,
}) => {

    return (
        <>
        <div className={styles.scoreBoardWrapper}>
            <img src={salbaLogo} alt={home.name} className={styles.logoHome} />
            <div className={styles.scoreBoard}>
                <div className={styles.topRow}>
                    <span className={styles.homeName}>{home.name}</span>
                    <span className={styles.awayName}>{away.name}</span>
                </div>
                <div className={styles.bottomRow}>
                    <span className={styles.teamScore}>{home.score}</span>
                    <div className={styles.clockSection}>
                        <span className={styles.periodTime}>{createPerodioTimeString(clock.periodTime)}</span>
                        <span className={styles.periodLabel}>{clock.period}. erä</span>
                    </div>
                    <span className={styles.teamScore}>{away.score}</span>
                </div>
            </div>
            <img src={karhutLogo} alt={away.name} className={styles.logoAway} />
        </div>
        <PenaltyBoard
            home={home}
            away={away}
        />
        </>
    );
};

export default ScoreBoard;